define(function(require) {
    // RESEAU_COLLEGIAL themeset definition config
    return  {
        ID : "ThemeSetGroup2",
        TYPE : "ThemeSetGroup",
        TITLE : "Graphiques provinciaux",
        THEMESETS_ELEMENTS : [
            {
                ID : "Provincial_2",
                TYPE : "ThemeSet",
                TITLE : "Contribution de la FGJ, FGA et FP dans le taux de diplomation et qualification par cohorte au secondaire après 5 et 7 ans",
            }, {
                ID : "Provincial_3",
                TYPE : "ThemeSet",
                TITLE : "Contribution des diplômes et des qualifications dans le taux de diplomation et qualification par cohorte au secondaire après 5 et 7 ans",
            }, {
                ID : "Provincial_4",
                TYPE : "ThemeSet",
                TITLE : "Taux de diplomation et de qualification par cohorte des élèves HDAA, après 5 et 7 ans, au réseau public, cohortes de 2007 à 2018",
                MASTER_THEMESETS_REMOVE: ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017"],
            }, {
                ID : "Provincial_5",
                TYPE : "ThemeSet",
                TITLE : "Taux de diplomation et de qualification par cohorte, après 5 et 7 ans, pour l'ensemble du Québec, cohortes de 2001 à 2018",
                MASTER_THEMESETS_REMOVE: ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017"],
            }
        ]
    };
});
